import { Box, Toolbar } from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import SideBar from "./SideBar";
import { useAppSelector } from "../../hooks/useAppSelector";

const Layout = () => {
  const { isAuthenticated } = useAppSelector((s) => s.auth);
  return (
    <Box sx={{ display: "flex" }}>
      <Header />
      {isAuthenticated && <SideBar />}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: "100%",
          overflow: "auto",
          margin: "1%",
        }}
      >
        <Toolbar />
        <Outlet />
        <Toolbar />
        <Footer />
      </Box>
    </Box>
  );
};

export default Layout;
